import { authFetch } from '../../utils/auth-fetch';
import { getApiUrl } from '../../utils/config';
import { useRestQuery } from '../wrappers';
// Import Timetable - POST /api/v1/untis/timetable/import
export const importUntisTimetable = async () => {
    return authFetch(`${getApiUrl()}/api/v1/untis/timetable/import`, {
        headers: {
            'Content-Type': 'application/json',
        },
        method: 'POST',
    });
};
// Sync Timetable - POST /api/v1/untis/timetable/sync
export const syncUntisTimetable = async () => {
    return authFetch(`${getApiUrl()}/api/v1/untis/timetable/sync`, {
        headers: {
            'Content-Type': 'application/json',
        },
        method: 'POST',
    });
};
export const resolveUntisLesson = async (periodId) => {
    const response = await authFetch(`${getApiUrl()}/api/v1/untis/lesson/resolve?period_id=${encodeURIComponent(periodId)}`, {
        headers: {
            'Content-Type': 'application/json',
        },
        method: 'GET',
    });
    if (!response.ok) {
        throw new Error(`Failed to resolve lesson: ${response.status}`);
    }
    return response.json();
};
// Hooks for React Query usage
export const useImportTimetableMutation = () => {
    return useRestQuery(async () => importUntisTimetable());
};
export const useSyncTimetableMutation = () => {
    return useRestQuery(async () => syncUntisTimetable());
};
